import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "burger",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 7.5v5h50v-5Zm0 15v5h50v-5Zm0 15v5h50v-5Z" }, null, -1)
  ]))]))
}
export default { render: render }